var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webContent flex" }, [
    _c("div", { staticClass: "release df cf" }, [
      _c("div", { staticClass: "title" }, [
        _c(
          "textarea",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.title,
                expression: "title"
              }
            ],
            attrs: { puc: "", placeholder: "输入标题" },
            domProps: { value: _vm.title },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.title = $event.target.value
              }
            }
          },
          [_vm._v(_vm._s(_vm.title))]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list flex" }, [
        _c("div", { staticClass: "info" }, [
          _vm._v("请上传PDF/图片/视频格式，视频控制在20s且50m以内")
        ]),
        _vm._v(" "),
        _vm.type == "img"
          ? _c("img", { attrs: { src: _vm.file, alt: "" } })
          : _vm.type == "video"
          ? _c("video", { attrs: { controls: "controls", src: _vm.file } })
          : _vm.type == "pdf"
          ? _c("div", [_vm._v("PDF文件：" + _vm._s(_vm.file))])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tool df hao" }, [
        _c("div", { staticClass: "btn flex" }, [
          _c("input", {
            attrs: { type: "file", accept: "*" },
            on: {
              change: function($event) {
                return _vm.toUpload($event.currentTarget)
              }
            }
          }),
          _vm._v("上传文件")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn btn2 flex", on: { click: _vm.submitRelease } },
          [_vm._v("发布")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59f59c99", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59f59c99","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/material/upload/upload.vue
// module id = null
// module chunks = 